import { clearLastRoute } from '../ui/lastRouteStorage';
import { setRevokedFlag, setSessionRevokedElsewhereFlag } from './sessionLiveness';

const REENTRY_WINDOW_MS = 2000;
let inFlight = false;
let lastDoneAt = 0;

/** Test seam: clears the re-entrancy guard. */
export function resetKickGuardForTests() {
  inFlight = false;
  lastDoneAt = 0;
}

/**
 * Force the signed-out "You were signed out." path for a session the server
 * has ended. Shared by useSessionRevocationWatch (signal) and PlatformRoute
 * (KAN-549 fallback re-check). Always the CONTEXT signOut, never raw supabase.
 *
 * Re-entrancy-safe: a second call while one is in flight, or within ~2s after,
 * is a no-op, so two signals can never produce a second SIGNED_OUT / notice.
 * The notice is set even if signOut throws.
 */
export async function kickSessionRevoked({ signOut, setAuthNotice }) {
  if (inFlight || Date.now() - lastDoneAt < REENTRY_WINDOW_MS) return;
  inFlight = true;
  try {
    clearLastRoute();
    setSessionRevokedElsewhereFlag();
    setRevokedFlag();
    await signOut();
  } finally {
    inFlight = false;
    lastDoneAt = Date.now();
    // ALWAYS set (KAN-549): the notice is app-global auth state, not the
    // caller's. The caller's own "cancelled" flag flips the moment signOut
    // clears the session (its effect re-runs), so gating on it silently
    // dropped the notice on every live-signal kick.
    setAuthNotice({ type: 'error', key: 'auth.notices.sessionRevokedElsewhere' });
  }
}
